import React from "react";
import { Button, Card, Col, ListGroup, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const AdminDetailsScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { state } = useLocation();

  const admins = state?.admins || [];
  const selectedAdminId = state?.selectedAdminId;
  const admin = admins.find((a) => a._id === selectedAdminId);

  return (
    <>
      <Row>
        <Col>
          <Button onClick={() => navigate("/allAdmins")}>Back</Button>
        </Col>
      </Row>
      <Row>
        <h5>Admin Details</h5>
        <Row>
          <Col md={5}>
            <Card>
              <ListGroup>
                <ListGroup.Item>
                  <Row>
                    <Col>
                      <strong>Admin Name</strong>
                    </Col>
                    <Col>
                      <strong>{admin?.adminName}</strong>
                    </Col>
                  </Row>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Row>
                    <Col>
                      <strong>Role</strong>
                    </Col>
                    <Col>
                      <strong>{admin?.role}</strong>
                    </Col>
                  </Row>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Row>
                    <Col>
                      <strong>Role Id</strong>
                    </Col>
                    <Col>
                      <strong>{admin?.roleId}</strong>
                    </Col>
                  </Row>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Row>
                    <Col>
                      <strong>Date of Birth </strong>
                    </Col>
                    <Col>
                      <strong>{admin?.dateOfBirth?.split("T")[0]}</strong>
                    </Col>
                  </Row>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Row>
                    <Col>
                      <strong>Address</strong>
                    </Col>
                    <Col>
                      <strong>{admin?.address}</strong>
                    </Col>
                  </Row>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Row>
                    <Col>
                      <strong>Mobile Number</strong>
                    </Col>
                    <Col>
                      <strong>{admin?.mobileNumber}</strong>
                    </Col>
                  </Row>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Row>
                    <Col>
                      <strong>Pincode</strong>
                    </Col>
                    <Col>
                      <strong>{admin?.pincode}</strong>
                    </Col>
                  </Row>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Row>
                    <Col>
                      <strong>Email </strong>
                    </Col>
                    <Col>
                      <strong>{admin?.email}</strong>
                    </Col>
                  </Row>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Row>
                    <Col>
                      <strong>Aadhar Number</strong>
                    </Col>
                    <Col>
                      <strong>{admin?.aadharNumber}</strong>
                    </Col>
                  </Row>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Row>
                    <Col>
                      <strong>PAN Number</strong>
                    </Col>
                    <Col>
                      <strong>{admin?.panNumber}</strong>
                    </Col>
                  </Row>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Row>
                    <Col>
                      <strong>Joined Date</strong>
                    </Col>
                    <Col>
                      <strong>{admin?.joinedDate?.split("T")[0]}</strong>
                    </Col>
                  </Row>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Row>
                    <Col>
                      <strong>Work Shift</strong>:
                    </Col>
                    <Col>
                      <strong>{admin?.workShift}</strong>
                    </Col>
                  </Row>
                </ListGroup.Item>
              </ListGroup>
            </Card>
          </Col>
        </Row>
      </Row>
    </>
  );
};

export default AdminDetailsScreen;
